import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dkn-admin-statuses mt-2" }
const _hoisted_2 = { class: "dkn-admin-status-header" }
const _hoisted_3 = { class: "dkn-admin-status-value" }
const _hoisted_4 = {
  key: 0,
  class: "dkn-mps-section"
}
const _hoisted_5 = { class: "asset-stats-grid" }
const _hoisted_6 = { class: "dkn-admin-status-header" }
const _hoisted_7 = { class: "dkn-admin-status-value" }
const _hoisted_8 = {
  key: 1,
  class: "dkn-mps-section"
}
const _hoisted_9 = { class: "asset-stats-grid" }
const _hoisted_10 = { class: "dkn-admin-status-header" }
const _hoisted_11 = { class: "dkn-admin-status-value" }
const _hoisted_12 = {
  key: 2,
  class: "dkn-mps-section"
}
const _hoisted_13 = { class: "asset-stats-grid" }
const _hoisted_14 = { class: "dkn-admin-status-header" }
const _hoisted_15 = { class: "dkn-admin-status-value" }
const _hoisted_16 = {
  key: 3,
  class: "dkn-mps-section"
}
const _hoisted_17 = { class: "asset-stats-grid" }
const _hoisted_18 = { class: "dkn-admin-status-header" }
const _hoisted_19 = { class: "dkn-admin-status-value" }
const _hoisted_20 = {
  key: 1,
  class: "modbus-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasAnyParam)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickStatuses, (status) => {
            return (_openBlock(), _createElementBlock("div", {
              key: status.key,
              class: _normalizeClass(["dkn-admin-status", status.toneClass])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(status.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(status.label), 1)
              ]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(status.value), 1)
            ], 2))
          }), 128))
        ]),
        (_ctx.temperatureItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dkn-mps-section-title" }, [
                _createElementVNode("i", { class: "bi bi-thermometer-half" }),
                _createElementVNode("span", null, "Temperatury")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temperatureItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.statusItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dkn-mps-section-title" }, [
                _createElementVNode("i", { class: "bi bi-toggles" }),
                _createElementVNode("span", null, "Statusy")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-circle-half" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.alarmItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dkn-mps-section-title" }, [
                _createElementVNode("i", { class: "bi bi-exclamation-triangle" }),
                _createElementVNode("span", null, "Alarmy")
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarmItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-exclamation-circle" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ioItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dkn-mps-section-title" }, [
                _createElementVNode("i", { class: "bi bi-diagram-3" }),
                _createElementVNode("span", null, "Wejścia / wyjścia")
              ], -1)),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ioItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-arrow-left-right" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("i", { class: "bi bi-thermometer-snow" }, null, -1),
        _createElementVNode("span", null, "Brak danych chłodni", -1)
      ]))]))
}